import axios from 'axios';
import {
  ExternalOrderModel,
  ExternalOrderStateEnum,
} from '../../external-orders/models/ExternalOrderModel';
import { TachoOrderFormValues } from '../models/TachoOrderModel';

const API_URL = process.env.REACT_APP_API_URL;
const TACHO_ORDERS_URL = `${API_URL}/api/tacho-orders/`;
export const ORDERS_PER_PAGE = 20;

interface ListTachoOrdersProps {
  page?: number;
  date__gte?: string;
  date__lte?: string;
  status?: ExternalOrderStateEnum;
}

interface TachoOrderListResponse {
  count: number;
  next: string;
  previous: string;
  results: Array<ExternalOrderModel>;
}

export function listTachoOrders({
  page = 1,
  date__gte,
  date__lte,
  status,
}: ListTachoOrdersProps): Promise<{ data: TachoOrderListResponse }> {
  const limit = ORDERS_PER_PAGE;
  const offset = (page - 1) * limit;
  return axios.get(TACHO_ORDERS_URL, {
    params: { limit, offset, date__gte, date__lte, status },
  });
}

export function getTachoOrder(
  id: number
): Promise<{ data: ExternalOrderModel }> {
  return axios.get(`${TACHO_ORDERS_URL}${id}/`);
}

export function createTachoOrder(
  data: TachoOrderFormValues
): Promise<{ data: ExternalOrderModel }> {
  return axios.post(TACHO_ORDERS_URL, data);
}

export function updateTachoOrder(
  id: number,
  data: Partial<TachoOrderFormValues>
): Promise<{ data: ExternalOrderModel }> {
  return axios.patch(`${TACHO_ORDERS_URL}${id}/`, data);
}

export enum TachoBulkActionsEnum {
  PREPARE_ORDERS = 'prepare_orders',
}

interface TachoBulkActionProps {
  orders: Array<number>;
  action: TachoBulkActionsEnum;
  date__gte?: string;
  date__lte?: string;
  status?: ExternalOrderStateEnum;
}

export function performTachoBulkAction({
  orders,
  action,
  date__gte,
  date__lte,
  status,
}: TachoBulkActionProps) {
  const endpoint = `${TACHO_ORDERS_URL}massive-actions/`;
  return axios.post(endpoint, { action, orders, date__gte, date__lte, status });
}
